(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchReportPhoto', PatchReportPhoto);

    PatchReportPhoto.$inject = ['$resource'];

    function PatchReportPhoto ($resource) {
        var resourceUrl =  'api/patch-report-photos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
